import { Button, Container, Grid, Typography } from "@mui/material";

import AlertModal from "components/AlertModal";
import { BankAccountDelete } from "store/api/BankAccounts";
import React from "react";
import http from "config/http";
import useNotify from "hooks/useNotify";

function ConfirmDeleteBankAccount({
  open,
  onClose,
  selectedBankAccount,
  getBankAccountList,
}) {
  const notify = useNotify();

  const getBankAccountDelete = async () => {
    try {
      await http.post(BankAccountDelete, { id: selectedBankAccount?.id });
      getBankAccountList();
      onClose();
    } catch (e) {
      notify(e?.response?.data?.message, "error");
    }
  };

  return (
    <AlertModal open={open} onClose={onClose} variant="error">
      <Container>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="h4" textAlign="center" mt={2}>
              آیا از حذف کارت بانکی مطمئن هستید؟
            </Typography>
          </Grid>

          <Grid item xs={6} my={2}>
            <Button color="info" fullWidth onClick={onClose}>
              انصراف
            </Button>
          </Grid>

          <Grid item xs={6} my={2}>
            <Button
              fullWidth
              color="error"
              onClick={() => getBankAccountDelete()}
            >
              حذف
            </Button>
          </Grid>
        </Grid>
      </Container>
    </AlertModal>
  );
}

export default ConfirmDeleteBankAccount;
